import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export const useUserLocation = () => {
    const { t } = useTranslation();
    const [userPosition, setUserPosition] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Geolocation not supported');
            return;
        }
        const watchId = navigator.geolocation.watchPosition((position) => {
            setUserPosition({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
            setError(null);
        }, (err) => {
            if (!userPosition) {
                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        setError(t('location.permission_denied'));
                        break;
                    case err.POSITION_UNAVAILABLE:
                        setError(t('location.position_unavailable'));
                        break;
                    case err.TIMEOUT:
                        setError(t('location.timeout'));
                        break;
                    default:
                        setError(t('location.unknown_error'));
                }
            }
        }, {
            enableHighAccuracy: true,
            maximumAge: 10000,
            // timeout: 90000,
        });
        return () => navigator.geolocation.clearWatch(watchId);
    }, []);
    return { userPosition, error };
};
